/**
 * 服务商名称映射工具
 * 用于将服务商标识符映射为全名
 */

// 图片服务商映射
export const IMAGE_PROVIDER_NAMES: Record<string, string> = {
  'grsai': 'Grsai Nano Banana',
  'volcengine': '火山引擎图片生成',
  'nano-banana': 'Grsai Nano Banana',
  'gnano': 'Grsai Nano', // gnano 是独立的服务商
  'custom': '自定义图片生成',
  'yan': 'Yan 图片生成', // 新增 yan 服务商
  'doubao': '火山引擎图片生成',
  '豆包': '火山引擎图片生成',
  '火山引擎': '火山引擎图片生成'
};

// 视频服务商映射
export const VIDEO_PROVIDER_NAMES: Record<string, string> = {
  'grsai': 'Grsai Sora2',
  'veo3': 'Veo3',
  'googleveo3': 'Google Veo3',
  'sora2': 'Sora2',
  'sora': 'Grsai Sora2',
  'minimax': 'Minimax',
  'doubao': '豆包视频'
};

/**
 * 从模型字符串中提取服务商名称
 * @param model 模型字符串，格式可能是 "provider-model" 或直接是模型名
 * @param type 类型：'image' 或 'video'
 * @returns 服务商全名
 */
export function getProviderName(model: string, type: 'image' | 'video'): string {
  if (!model) return type === 'image' ? '图片生成' : '视频生成';
  
  // 如果是 TEXT_TO_IMAGE，返回默认值
  if (model === 'TEXT_TO_IMAGE') return '图片生成';
  
  // 如果有 - 分隔符，取第一个部分作为服务商标识符
  if (model.includes('-')) {
    const parts = model.split('-');
    const providerKey = parts[0].toLowerCase();
    
    if (type === 'image') {
      // 🔥 自动推断：如果映射中没有，根据模型名推断
      if (IMAGE_PROVIDER_NAMES[providerKey]) {
        return IMAGE_PROVIDER_NAMES[providerKey];
      } else if (model.includes('nano')) {
        return `${providerKey} 图片生成`; // 自动生成名称
      } else {
        return `${providerKey} 图片生成`;
      }
    } else {
      return VIDEO_PROVIDER_NAMES[providerKey] || `${providerKey} 视频生成`;
    }
  }
  
  // 没有分隔符的情况，根据模型名推断服务商
  if (type === 'image') {
    if (model.includes('nano')) {
      return 'Grsai Nano Banana';
    } else if (model.includes('doubao')) {
      return '火山引擎图片生成';
    }
    return model; // 直接返回模型名
  } else {
    if (model.includes('sora')) {
      return 'Grsai Sora2';
    } else if (model.includes('veo')) {
      return 'Veo3';
    }
    return model; // 直接返回模型名
  }
}

/**
 * 从模型字符串中提取模型名称（去除服务商前缀）
 * @param model 模型字符串
 * @returns 纯模型名称
 */
export function getModelName(model: string): string {
  if (!model) return '';
  
  // 如果是 TEXT_TO_IMAGE，返回默认值
  if (model === 'TEXT_TO_IMAGE') return '图片生成';
  
  // 如果有 - 分隔符，取最后一个部分（模型名称）
  if (model.includes('-')) {
    return model.split('-').pop() || model;
  }
  
  // 直接返回模型名称
  return model;
}

/**
 * 根据服务商标识符获取服务商全名
 * @param providerKey 服务商标识符（如 'grsai', 'volcengine'）
 * @param type 类型：'image' 或 'video'
 * @returns 服务商全名
 */
export function getProviderNameByKey(providerKey: string, type: 'image' | 'video'): string {
  if (!providerKey) return type === 'image' ? '图片生成' : '视频生成';
  
  const key = providerKey.toLowerCase();
  
  if (type === 'image') {
    return IMAGE_PROVIDER_NAMES[key] || key;
  } else {
    return VIDEO_PROVIDER_NAMES[key] || key;
  }
}
